export enum DataDisplayMode {
  table = "table",
  charts = "charts",
  barcharts = "barcharts",
}
